<template>
  <b-card class="mb-4" header-bg-variant="custom" no-body>
    <template #header>
      <h4 class="text-white">{{ title }}</h4>
    </template>
    <b-card-body>
      <b-row>
        <b-col class="col-12" v-if="period_info">
          <p class="text-muted">{{ period_info }}</p>
        </b-col>
        <b-col class="col-12">
          <GChart
            type="ColumnChart"
            :data="data"
            :options="options"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    period_info: { type: String, default: null },
    data: { type: Array, required: true },
    options: { type: Object, required: true },
  },
  data() {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [
        ["Year", "Sales", "Expenses", "Profit"],
        ["2014", 1000, 400, 200],
        ["2015", 1170, 460, 250],
        ["2016", 660, 1120, 300],
        ["2017", 1030, 540, 350],
      ],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017",
        },
      },
    };
  },
};
</script>

<style>
</style>